import { useEffect, useState } from "react";
import { getKokoTaxRate } from "../api";

const useKokoTaxRate = () => {
  const [kokoTaxRate, setKokoTaxRate] = useState(null);
  const [kokoTaxRateStatus, setKokoTaxRateStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    getKokoTaxRate()
      .then((rate) => {
        if (cancelled) return;
        if (Number.isFinite(rate)) {
          setKokoTaxRate(rate);
          setKokoTaxRateStatus("ready");
        } else {
          setKokoTaxRateStatus("error");
        }
      })
      .catch((error) => {
        console.error("Error loading KOKO tax rate:", error);
        if (!cancelled) setKokoTaxRateStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { kokoTaxRate, kokoTaxRateStatus };
};

export default useKokoTaxRate;
